import { render, staticRenderFns } from "./person-picker.vue?vue&type=template&id=e824b43e&"
import script from "./person-picker.vue?vue&type=script&lang=js&"
export * from "./person-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports